'use client'

import Link from 'next/link'
import Image from 'next/image'
import { Phone, MapPin } from 'lucide-react'
import { PHONE } from '@/const'

const Footer = () => {
    const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, section: string) => {
        e.preventDefault()
        const element = document.querySelector(section)
        element?.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <footer className="border-t border-border bg-background-card">
            <div className="max-w-max-width mx-auto p-12 px-8">
                <div className="grid gap-8 md:grid-cols-4">
                    {/* О компании */}
                    <div>
                        <Link href={'/'} className="flex items-center gap-2 mb-4 no-underline">
                            <Image src="/img/logo.svg" alt="Банкрот Консалт" className="h-8 w-8" width={40} height={40} />
                            <span className="font-bold text-foreground">Банкрот Консалт</span>
                        </Link>
                        <p className="text-sm text-muted-foreground leading-relaxed">
                            Банкротство физических лиц, реструктуризация долгов
                            </p>

                        <Link
                            href='/agreement'
                            className="mt-4 block text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200"
                        >
                            Пользовательское соглашение
                        </Link>
                        <Link
                            href='/privacy'
                            className="block text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200"
                        >
                            Политика конфиденциальности
                        </Link>
                    </div>

                    {/* Контакты */}
                    <div className="min-w-0">
                        <h4 className="font-semibold text-foreground mb-3">Контакты</h4>
                        <div className="flex flex-col gap-3">
                            {/* Телефон */}
                            <a href={`tel:${Object.keys(PHONE)[0]}`} className="flex items-center gap-2 no-underline group">
                                <Phone className="h-4 w-4 text-primary shrink-0" />
                                <div className="flex flex-col">
                                    <span className="text-base font-semibold text-foreground group-hover:text-primary transition-colors duration-200">{PHONE['+74992888087']}</span>
                                    <span className="text-xs text-muted-foreground">Круглосуточно · Бесплатно</span>
                                </div>
                            </a>

                            {/* MAX Messenger */}
                            <a href="https://max.ru/id7704250024_3_bot" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 py-2 rounded-xl no-underline transition-colors duration-200">
                                <Image src="/img/Max_logo_2025.png" alt="MAX Messenger" className='w-8 h-8' width={32} height={32} />
                                <span className="text-sm font-medium leading-[1.3]">Задай вопрос юристу в MAX</span>
                            </a>

                            {/* Адрес */}
                            <div className="flex items-start gap-2 text-sm text-muted-foreground">
                                <MapPin className="h-4 w-4 text-primary shrink-0 mt-0.5" />
                                <span>119021, г. Москва, Комсомольский проспект, д. 16/2, с. 3</span>
                            </div>
                        </div>
                    </div>

                    {/* Навигация */}
                    <div className="min-w-0">
                        <h4 className="font-semibold text-foreground mb-3">Навигация</h4>
                        <div className="flex flex-col gap-2">
                            <a href="#how" onClick={(e) => handleNavClick(e, '#how')} className="text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200">
                                Как это работает
                            </a>
                            <a href="#features" onClick={(e) => handleNavClick(e, '#features')} className="text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200">
                                Возможности
                            </a>
                            <a href="#calc" onClick={(e) => handleNavClick(e, '#calc')} className="text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200">
                                Калькулятор
                            </a>
                            <Link href="/auth" className="text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200">
                                Войти
                            </Link>
                            <Link href="/recomendation" className="text-sm text-muted-foreground no-underline hover:text-foreground transition-colors duration-200">
                                Программа рекомендаций
                            </Link>
                        </div>
                    </div>

                    {/* Мы в сети */}
                    <div className="min-w-0">
                        <h4 className="font-semibold text-foreground mb-3">Мы в сети</h4>
                        <div className="flex gap-3 items-center">
                            <a href="https://vk.com/bankrotconsult_ru" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-[rgba(0,124,186,0.1)] flex items-center justify-center text-primary no-underline hover:bg-[rgba(0,124,186,0.2)] transition-colors duration-200" title="ВКонтакте">
                                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                                    <path d="M15.684 0H8.316C1.592 0 0 1.592 0 8.316v7.368C0 22.408 1.592 24 8.316 24h7.368C22.408 24 24 22.408 24 15.684V8.316C24 1.592 22.408 0 15.684 0zm3.692 17.123h-1.744c-.66 0-.864-.525-2.05-1.727-1.033-1-1.49-1.135-1.744-1.135-.356 0-.458.102-.458.593v1.575c0 .424-.135.678-1.253.678-1.846 0-3.896-1.12-5.339-3.202-2.17-3.048-2.763-5.339-2.763-5.814 0-.254.102-.491.593-.491h1.744c.44 0 .61.203.78.678.864 2.491 2.303 4.675 2.896 4.675.22 0 .322-.102.322-.66V9.721c-.068-1.186-.695-1.287-.695-1.71 0-.203.17-.407.44-.407h2.744c.373 0 .508.203.508.643v3.473c0 .372.17.508.271.508.22 0 .407-.136.813-.542 1.254-1.406 2.151-3.574 2.151-3.574.119-.254.322-.491.763-.491h1.744c.525 0 .644.27.525.643-.22 1.017-2.354 4.031-2.354 4.031-.186.305-.254.44 0 .78.186.254.796.779 1.203 1.253.745.847 1.32 1.558 1.473 2.05.17.49-.085.744-.576.744z"></path>
                                </svg>
                            </a>
                            <a href="https://dzen.ru/bankrotconsult" target="_blank" rel="noopener noreferrer" className="w-9 h-9 rounded-lg bg-[rgba(0,124,186,0.1)] flex items-center justify-center text-primary no-underline hover:bg-[rgba(0,124,186,0.2)] transition-colors duration-200" title="Дзен">
                                <svg viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
                                    <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.894 13.894c-1.63 3.238-3.132 4.74-6.37 6.37-3.238-1.63-4.74-3.132-6.37-6.37 1.63-3.238 3.132-4.74 6.37-6.37 3.238 1.63 4.74 3.132 6.37 6.37z"></path>
                                </svg>
                            </a>

                            <Image src="/img/sk-member.svg" alt="Судебный член" className="w-25 h-15" width={100} height={60} />
                        </div>
                        <p className="text-xs text-muted-foreground leading-relaxed mt-2">
                            Банкротство влечет негативные последствия, в том числе ограничения на получение кредита и повторное банкротство в течение пяти лет. Предварительно
                            обратитесь к своему кредитору и в МФЦ
                        </p>
                    </div>
                </div>
            </div>

            <div className="border-t border-border">
                <div className="max-w-max-width mx-auto px-8">
                    <div className="py-4 flex flex-col md:flex-row items-center md:justify-between gap-2">
                        <p className="text-xs text-muted-foreground">ООО &quot;Банкрот Консалт&quot; © 2009-2026</p>
                        <p className="text-xs text-muted-foreground">ИНН: 7704250024, ОГРН: 1027704015448</p>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer
